(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'CpApiLogSearch',
	};

	var $form,
	    click_timeout;

	var _displayXml;

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		$form = $(form.element);

		$form.find('.log-entry-cb').on('click', function click(e) {
			if ($(this).prop('checked')) {
				if ($form.find('.log-entry-rb:checked').length === 0) {
					$(this).parent().parent().find('.log-entry-rb').prop('checked', true);
				}

				$(this).parent().parent().addClass('row-selected');
			} else {
				$(this).parent().parent().removeClass('row-selected');
			}
		});

		$form.find('.log-entry').on('click', function click(e) {
			var $checkbox;

			if (!$(e.target).is('td')) {
				return;
			}

			clearTimeout(click_timeout);

			$checkbox = $(this).find(':checkbox');

			click_timeout = setTimeout(function timeout() {
				$checkbox.trigger('click');
			}, 250);
		});

		$form.find('.log-entry').on('dblclick', function click(e) {
			if (!$(e.target).is('td')) {
				return;
			}

			clearTimeout(click_timeout);

			_displayXml($(this));
		});

		$form.find('.log-entry-view-xml').on('click', function click(e) {
			e.preventDefault();

			_displayXml($(this).parent().parent());
		});

		$form.find('.log-entry-send-sabre').on('click', function click(e) {
			e.preventDefault();

			$('#cpapilogsearch-action').val('send_sabre');

			$form.submit();
		});

		$form.find('.log-entry-download').on('click', function click(e) {
			e.preventDefault();

			$('#cpapilogsearch-action').val('download');

			$form.submit();
		});
	};

	form.success = function success(response)
	{
		if (!Adzuki.Form.hasError(response)) {
			window.location.href = response['data'];

			if ($('#cpapilogsearch-action').val() === 'download') {
				$('#cpapilogsearch-action').val('');
			} else {
				return true;
			}
		}

		return false;
	};

	_displayXml = function _displayXml($td)
	{
		var request_log_id = $td.find(':checkbox').val(),
		    $modal         = $('.modal');

		$modal.addClass('wide');
		$modal.find('.modal-title').text('Log Entry XML');
		$modal.find('.modal-body').html('XML Request:<iframe style="width: 100%; height: 250px" src="' + Adzuki.base_uri + '/CpApiLog/getXml/' + request_log_id + '/request" type="text/xml"></iframe>XML Response:<iframe style="width: 100%; height: 450px" src="' + Adzuki.base_uri + '/CpApiLog/getXml/' + request_log_id + '/response" type="text/xml"></iframe>');
		$modal.on('hidden.bs.modal', function _restoreModal() {
			$modal.removeClass('wide').off('hidden.bs.modal');
		}).modal('show');
	};

}(jQuery, window.Adzuki || {}));
